<form (ngSubmit)="onSubmit()" class="w-full">
    <div class="p-4 text-white bg-primary">
        <h2 class="uppercase font-bold">
            {{ "QUOTATION.QUOTATION_REQUEST" | translate }}
        </h2>
    </div>

    <div class="p-4 space-y-2">
        @if (data.withSave){

            @if (projectStore.id()){

                <div class="space-x-2">
                    <h2 class="uppercase font-semibold text-primary-500"> {{ "SAVE.CURRENT_PROJECT" | translate }}:</h2>
                    <div class="bg-gray-200 p-2 flex justify-between" (click)="handleProjectReferenceRemoval()">
                        <h3 class="self-center">{{ projectStore.name() }}</h3>
                        <img src="assets/images/icons/close.svg" alt="" width="32" height="32" class="cursor-pointer rounded-md hover:bg-gray-300"/>
                    </div>
                </div>

            } @else {

                <div class="space-x-2">
                    <label>{{ "GLOBAL.PROJECT" | translate }}*</label>
                    <app-input class="block" [formController]="quotationForm.controls.projectName" [initialValue]="quotationForm.value.projectName"/>
                    @if (isInvalid() && quotationForm.controls.projectName.invalid){
                        <label class="text-sm text-red-400">{{ "GLOBAL.REQUIRED_VALUE" | translate }}</label>
                    }
                </div>

            }

            @if (lamellaAreaStore.pristine() && projectStore.projectRecord()){

                <div class="space-x-2">
                    <h2 class="uppercase font-semibold text-primary-500"> {{ "SAVE.CURRENT_PROJECT_RECORD" | translate }}:</h2>
                    <div class="bg-gray-200 p-2 flex justify-between" (click)="handleProjectRecordReferenceRemoval()">
                        <h3 class="self-center">{{ projectStore.projectRecord().name }}</h3>
                        <img src="assets/images/icons/close.svg" alt="" width="32" height="32" class="cursor-pointer rounded-md hover:bg-gray-300" />
                    </div>
                </div>

            } @else {

                <div class="space-x-2">
                    <label>{{ "GLOBAL.PROJECT_RECORD" | translate }}*</label>
                    <app-input class="block" [formController]="quotationForm.controls.projectRecordName" [initialValue]="quotationForm.value.projectRecordName"/>
                    @if (isInvalid() && quotationForm.controls.projectRecordName.invalid){
                        <label class="text-sm text-red-400">{{ "GLOBAL.REQUIRED_VALUE" | translate }}</label>
                    }
                </div>

            }

        }

        <div class="space-x-2">
            <label>{{ "GLOBAL.EMAIL" | translate }}*</label>
            <app-input class="block" [formController]="quotationForm.controls.email" [initialValue]="quotationForm.value.email"/>

            @if (isInvalid() && quotationForm.controls.email?.errors && quotationForm.controls.email?.errors["required"]){
                <label class="text-sm text-red-400">{{ "GLOBAL.REQUIRED_VALUE" | translate }}</label>

            } @else if (isInvalid() && quotationForm.controls.email?.errors && quotationForm.controls.email?.errors["email"]){
                <label class="text-sm text-red-400">{{ "GLOBAL.INVALID_EMAIL" | translate }} </label>

            }

        </div>
        <div class="space-x-2">
            <label>{{ "GLOBAL.PHONE_NUMBER" | translate }}*</label>
            <app-input class="block" [formController]="quotationForm.controls.phone" [placeholder]="'+358 ...'"/>
            @if (isInvalid() && quotationForm.controls.phone.invalid){
                <label class="text-sm text-red-400">{{ "GLOBAL.REQUIRED_VALUE" | translate }} </label>
            }
        </div>
        <div class="space-x-2">
            <label>{{ "GLOBAL.COMPANY.COMPANY" | translate }}</label>
            <app-input class="block" [formController]="quotationForm.controls.companyName" [initialValue]="quotationForm.value.companyName"/>
        </div>
        <div class="space-x-2 flex flex-col">
            <label>{{ "GLOBAL.DESCRIPTION" | translate }}</label>
            <textarea class="w-auto border-gray-400 border me-2 min-h-52" [formControl]="quotationForm.controls.description"> </textarea>
        </div>
        <div class="space-x-2">
            <span class="text-sm text-gray-400">* = {{ "GLOBAL.REQUIRED_VALUE_NOTIFIER" | translate }} </span>
        </div>
    </div>

    <div class="p-4 flex justify-center">
        <button type="submit" class="w-min px-3 py-1 bg-secondary text-white font-bold rounded" > {{ "GLOBAL.SUBMIT" | translate }} </button>
    </div>
</form>